// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__TpYvj","addWidgetButton":"Header_addWidgetButton__30Z2d","dashboardTabs":"Header_dashboardTabs__2XTSo","active":"Header_active__2atDO"};